module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/5_5e8481309e86e4e3243180266cf3166e.jpg";